import axios from "../common/axiosHttp.js";
import JSEncrypt from "jsencrypt";
import md5 from "js-md5";
import Vue from "vue";
import screenfull from "screenfull";
axios.defaults.baseURL = "";

const apiUrl = {
  // xnmlUrl: "http://localhost:8996/ptmainApi"
  xnmlUrl: "https://www.youfanglianmai.com/ptmainApi"
};

// http请求工具包
const handler = {
  paramData: {
    headerData: { 
      ssid: "",
      op: "", //反射名称
      methodName: "" //对应的方法名
    },
    busData: {} //参数内容
  },
  // 发送Post请求，公共方法
  sendPost() {
    var loading = "";
    var requestUrl = "";
    var isLoadingShow = false;
    if (this.paramData.headerData.op === "login") {
      requestUrl = apiUrl.xnmlUrl + "/login";
      isLoadingShow = false;
    } else {
      requestUrl = apiUrl.xnmlUrl;
      if (this.paramData.headerData.op === "trialItemGl") {
        if (this.paramData.busData.isjl === "1") {
          isLoadingShow = true;
        } else {
          isLoadingShow = false;
        }
      } else {
        isLoadingShow = true;
      }

      if (isLoadingShow) {
        loading = Vue.prototype.$loading({
          lock: true, //lock的修改符--默认是false
          text: "Loading", //显示在加载图标下方的加载文案
          spinner: "el-icon-loading", //自定义加载图标类名
          background: "rgba(0, 0, 0, 0.7)", //遮罩层颜色
          target: document.querySelector("#table") //loadin覆盖的dom元素节点
        });
      }
    }

    var paramJson = JSON.stringify(this.paramData);
    let Base64 = require("js-base64").Base64;
    let baseStr = Base64.encode(paramJson);
    var sendParam = {
      paramData: baseStr,
      mac: md5(baseStr + "trialSystem000000000001")
    };
    let paramBase64 = Base64.encode(JSON.stringify(sendParam));
    return new Promise((resolve, reject) => {
      axios.post(requestUrl, paramBase64).then(
        response => {
          if (this.paramData.headerData.op === "login") {
          } else {
            if (isLoadingShow) {
              //成功回调函数停止加载
              loading.close();
            }
          }
          var data = response.data;
          // alert(JSON.stringify(data))
          if (data.code === "-1") {
            if (this.paramData.headerData.op === "getSsInfo") {
            } else {
              // alert(data.msg);
            }
            window.location.href = "/";
          } else {
            resolve(data);
          }
        },
        err => {
          //成功回调函数停止加载
          if (this.paramData.headerData.op === "login") {
          } else {
            if (isLoadingShow) {
              //成功回调函数停止加载
              loading.close();
            }
          }
          // alert('网络异常：' + err.data)
        }
      );
    });
  },

  //发送post请求，不带loading动画的
  sendPostNoLoading() {
    var requestUrl = apiUrl.xnmlUrl;

    var paramJson = JSON.stringify(this.paramData);
    let Base64 = require("js-base64").Base64;
    let baseStr = Base64.encode(paramJson);
    var sendParam = {
      paramData: baseStr,
      mac: md5(baseStr + "trialSystem000000000001")
    };
    let paramBase64 = Base64.encode(JSON.stringify(sendParam));
    return new Promise((resolve, reject) => {
      axios.post(requestUrl, paramBase64).then(
        response => {
          if (this.paramData.headerData.op === "login") {
          } else {
          }
          var data = response.data;
          // alert(JSON.stringify(data))
          if (data.code === "-1") {
            window.location.href = "/";
          } else {
            resolve(data);
          }
        },
        err => {
          //成功回调函数停止加载
          if (this.paramData.headerData.op === "login") {
          } else {
          }
          //alert('网络异常：' + err.data)
        }
      );
    });
  },
  // 转换Json中key的大小写  type：0 大写  type：1 首字母大写  type：2 全部小写
  jsonToKey(json, type) {
    for (var key in json) {
      var item = json[key];
      delete json[key];
      switch (type) {
        case 0:
          // key值全部大写
          json[key.toLocaleUpperCase()] = item;
          break;
        case 1:
          // key值首字母大写，其余小写
          json[
            key.substring(0, 1).toLocaleUpperCase() +
              key.substring(1).toLocaleLowerCase()
          ] = item;
          break;
        default:
          // 默认key值全部小写
          json[key.toLocaleLowerCase()] = item;
          break;
      }
    }
    return json;
  },
  // rsa公钥加密
  rsaEn(str) {
    // MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA2ditw1VU2oXKdRs3eHKCennx97eg+/eH6rsu3T1EccDNKBvCCbS3tvmq++sfgTVuuQkYhQuce+yxpJFUuyx2FIF8FaIiOembb8Q9pBT2ds1LD7kzydXhyydOQhjWArAjY0qwmTpq6y7kwsgtH6m6rde4oXw5P2Pz1CW2QnaFHQXrRj0Q2KUwaS401UUhpzdONY0VWRTCsqoc5+ohSBQr8C//MnVUmbUjDMNUn4002serTAzAeWvmmiGvzu5oVhBLmZHwBs97YRDiSgROo8wZmQBoBQOxmNN7KfhqhnFNRYp7J09/1lc6UVj5cYzGMbRB6Pzxr7Ja2P1eQsDtWCi3TwIDAQAB
    // MIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQDZ2K3DVVTahcp1Gzd4coJ6efH3t6D794fquy7dPURxwM0oG8IJtLe2+ar76x+BNW65CRiFC5x77LGkkVS7LHYUgXwVoiI56ZtvxD2kFPZ2zUsPuTPJ1eHLJ05CGNYCsCNjSrCZOmrrLuTCyC0fqbqt17ihfDk/Y/PUJbZCdoUdBetGPRDYpTBpLjTVRSGnN041jRVZFMKyqhzn6iFIFCvwL/8ydVSZtSMMw1SfjTTax6tMDMB5a+aaIa/O7mhWEEuZkfAGz3thEOJKBE6jzBmZAGgFA7GY03sp+GqGcU1FinsnT3/WVzpRWPlxjMYxtEHo/PGvslrY/V5CwO1YKLdPAgMBAAECggEAaVyMBipyRNJqriMAvCeeBcCPEAFnQhZhTV1E+EoWnXHjh9+NBIa8SCoO0ZLRhPuj1qiYjFimUaWT8YU81t5VKevKaOgm552dyPu/2GkvHxyBjlRDwP3KHCihiARdFaW9J9vK+AEyDxd6Gt8YO/UqTcRFDw123rroBhZLRW/vR65di8gKnQ1QbWEsO+IcYENdi9s05Y/7mzw+DJCFndcj+I+scf3H9C+ShC2dj4sk5Zdu3qk6+HUCRMw1WnuJeY2lyH4YNWun0oIRobNgbVmJDRKFIkeY8L9MJ1JZVvubOpdQa838aN/+HD6A1ck/UA657WKcm+r6KyB6fMR5XhQPCQKBgQD2i1a6k9iL1o0cQH0wWNe3zZ6Q2qzf9CHipBOVxAeW4xvpWHE91QGynxBh3DnpUFMCT4JSDm3L7Kv5wfV9mrcZBvxQJPgpxOb4Nw3TJti3oPz69yxBgNKEebT7tx/o+5/67Z1+1qvU3LSjg3epFHxI6kL+vbG47wB1YdnYweDpRQKBgQDiM5LdCkUPKRTBFpl37gwgdJLJde0tsTL4VIkdRu+5/Ln54J7mNG03dYYohMqnWzjJFOYJpGiN6g3B8ycZOjRh2/XRWLAAJCwkb8Dck90tXrFsg7paSuZYKJMYBoNTrpGYTvcpOH4J+LQXnA6gpSdJaV0gSlq3flbmn4pBpCcFgwKBgDV6tC10tJxgxetC8eTy4Jg2Ohch2C4cPt1yyezKwPqx+PP9A1NuSRf9+QfBRa6eheMSbCpwhtCdXhCnSiEc1mrPYRvhaRNmatOc3ZrX6lqqyTWHOEpdL00dOW0ApCNdsa40rN0+o7dgyK5Pbj12/B608iNf8pUzAt5zg1XJeIghAoGAL1yREYsG7qexWsR6mavUCi+eVGRGptyFSY2Zr/GcXBrYbcNkQdsUSxpmXrF/JQ9qkl+30qkD40LwYn2g4B1Zvmupyo2BPGZWf8KOZSDonIlJKOlj6WfpVugX9F3YvXq9rWBLS+wyJ7BVNOROA8DQuwQ+pXYsDGN9mogpEJloOjUCgYEA4o+DxUiOyuDSRJJYWl2lII3D+7symuexf+tpqsKR7w434e3eODiXgy/TzPzV58rbXtUeKnKHLrYgooOq8J9n8f+7pf0SBUdbvRYMtzYxt8Gxyk7uj3zQndpbNUylQWBhXxiTMi2i6iaxChZcGsVdauC+Qe87E/Cgq/S6PFw2t+o=
    const pubKey =
      "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA2ditw1VU2oXKdRs3eHKCennx97eg+/eH6rsu3T1EccDNKBvCCbS3tvmq++sfgTVuuQkYhQuce+yxpJFUuyx2FIF8FaIiOembb8Q9pBT2ds1LD7kzydXhyydOQhjWArAjY0qwmTpq6y7kwsgtH6m6rde4oXw5P2Pz1CW2QnaFHQXrRj0Q2KUwaS401UUhpzdONY0VWRTCsqoc5+ohSBQr8C//MnVUmbUjDMNUn4002serTAzAeWvmmiGvzu5oVhBLmZHwBs97YRDiSgROo8wZmQBoBQOxmNN7KfhqhnFNRYp7J09/1lc6UVj5cYzGMbRB6Pzxr7Ja2P1eQsDtWCi3TwIDAQAB"; // ES6 模板字符串 引用 rsa 公钥
    const encryptStr = new JSEncrypt();
    encryptStr.setPublicKey(pubKey); // 设置 加密公钥
    const data = encryptStr.encrypt(
      str.toString() + "|spjaSGGOv6OtzioNsfOZWAt6DL5LnlNz"
    ); // 进行加密
    return data;
  },
  //获取权限，同步请求
  getUserUis(fn) {
    var requestData = {
      headerData: {
        ssid: "",
        op: "getUserSeesion", //反射名称
        methodName: "" //对应的方法名
      },
      busData: {} //参数内容
    };
    this.paramData = requestData;
    this.sendPostNoLoading().then(data => {
      if (!data.isSuccess) {
        alert(data.msg);
        fn({});
        return;
      }
      fn(data.content);
    });
  },
  screenFull(dom) {
    if (!screenfull.isEnabled) {
      // 如果不支持进入全屏，发出不支持提示
      alert("您的浏览器不支持全屏");
      return;
    }
    // alert(JSON.stringify(dom));
    //此处填入需要全屏的ref属性值即可
    screenfull.toggle(dom);
  },
  getStrLength(str) {
    if (str === undefined) {
      return 0;
    } else {
      return str.length;
    }
  }
};

export default { handler, apiUrl };



// WEBPACK FOOTER //
// ./src/common/util.js